<template>
  <div>
    <p class="widget-auth-info">
      <strong>
        {{ $tc("thankYouForRegistering") }}
        <br />
        {{ $tc("weSendAnEmailForVerification") }}
      </strong>
    </p>
    <br />
    <br />
    <h4 class="text-center">
      {{ $tc("logInByClickingOnTheLink") }}
      <br />
    </h4>
    <p class="widget-auth-info">
      <br />
      <br />
    </p>

    <p class="widget-auth-info">
      {{ $tc("psCheckYourSpam") }}
    </p>
  </div>
</template>

<script>
export default {
  name: "LoginWaitingView",
  components: {}
};
</script>

<style scoped lang="scss"></style>
